import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mailTo',
  standalone: false,
})
export class MailToPipe implements PipeTransform {
  transform(mails: string[]) {
    return `mailto:${mails.join(';')}`;
  }
}
